import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography, Box } from '@mui/material';

interface EditTeamProfileModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (teamName: string, logoUrl: string, description: string) => void;
  team: { id: string; name: string; logoUrl?: string; description?: string } | null;
}

const EditTeamProfileModal: React.FC<EditTeamProfileModalProps> = ({ open, onClose, onSave, team }) => {
  const [teamName, setTeamName] = useState<string>('');
  const [logoUrl, setLogoUrl] = useState<string>('');
  const [description, setDescription] = useState<string>('');

  useEffect(() => {
    if (team) {
      setTeamName(team.name);
      setLogoUrl(team.logoUrl || '');
      setDescription(team.description || '');
    }
  }, [team]);

  const handleSave = () => {
    if (teamName) {
      onSave(teamName, logoUrl, description);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Edit Team Profile</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="team-name"
          label="Team Name"
          type="text"
          fullWidth
          variant="outlined"
          value={teamName}
          onChange={(e) => setTeamName(e.target.value)}
          sx={{ mb: 2 }}
        />
        <TextField
          margin="dense"
          id="logo-url"
          label="Logo URL"
          type="url"
          fullWidth
          variant="outlined"
          value={logoUrl}
          onChange={(e) => setLogoUrl(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
          For now, please use a direct URL to your team logo. Image upload functionality will be added in a later phase.
        </Typography>
        <TextField
          margin="dense"
          id="team-description"
          label="Team Description (Optional)"
          type="text"
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          sx={{ mb: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditTeamProfileModal;
